import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { AWSXRayPropagator } from '@opentelemetry/propagator-aws-xray';
import { trace } from '@opentelemetry/api';

const provider = new WebTracerProvider();
const currentOrigin = window.location.origin;
const sameOriginPattern = new RegExp(`^${currentOrigin.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`);

provider.register({
  contextManager: new ZoneContextManager(),
  propagator: new AWSXRayPropagator(),
});

registerInstrumentations({
  instrumentations: [
    getWebAutoInstrumentations({
      '@opentelemetry/instrumentation-fetch': {
        // No propagar trace headers a Keycloak u otros terceros para evitar fallas de CORS en OIDC.
        propagateTraceHeaderCorsUrls: sameOriginPattern,
      },
      '@opentelemetry/instrumentation-xmlHttpRequest': {
        propagateTraceHeaderCorsUrls: sameOriginPattern,
      },
    }),
  ],
});

const tracer = trace.getTracer('mgdr-front');

export { tracer, provider };
